import React, {useEffect} from 'react';
import './dot-section.scss';

const DotSection = (props) => {
    let counter = 1;

    useEffect(() => {
        colorSwitch();
    }, []);

    const colorSwitch = () => {
        setTimeout(() => {
            alternateColors();
        }, 3000);
    }

    const alternateColors = () => {
        let step1 = document.getElementsByClassName('step-1')[0];
        let step2 = document.getElementsByClassName('step-2')[0];
        let step3 = document.getElementsByClassName('step-3')[0];

        let header1 = document.getElementsByClassName('header-1')[0];
        let header2 = document.getElementsByClassName('header-2')[0];
        let header3 = document.getElementsByClassName('header-3')[0];

        let dot1 = document.getElementsByClassName('dot-1')[0];
        let dot2 = document.getElementsByClassName('dot-2')[0];
        let dot3 = document.getElementsByClassName('dot-3')[0];


        if (counter === 1) {
            step1.style.color = "#F0C17D";
            header1.style.color = "#F0C17D";
            dot1.style.backgroundColor = "#F0C17D";

            step3.style.color = "#FFF";
            header3.style.color = "#FFF";
            dot3.style.backgroundColor = "rgba(51, 30, 56, 0)";
            counter++;

        } else if (counter === 2) {
            step2.style.color = "#F0C17D";
            header2.style.color = "#F0C17D";
            dot2.style.backgroundColor = "#F0C17D";

            step1.style.color = "#FFF";
            header1.style.color = "#FFF";
            dot1.style.backgroundColor = "rgba(51, 30, 56, 0)";

            counter++;
        } else if (counter === 3) {
            step3.style.color = "#F0C17D";
            header3.style.color = "#F0C17D";
            dot3.style.backgroundColor = "#F0C17D";

            step2.style.color = "#FFF";
            header2.style.color = "#FFF";
            dot2.style.backgroundColor = "rgba(51, 30, 56, 0)";
            counter = 1;
        }
        colorSwitch();
    }

    return (
        <div className="dot-section-container">
            <div className="dot-section-content">
                <div className="dot-section-text">
                    It's as Convenient as <span className="break-desktop">One, Two, Three</span>
                </div>
                <div className="process-column-container">
                    <div className="left-column">
                        <div className="dot-container">
                            <div className="step-dot dot-1"/>
                            <div className="step-line"/>
                        </div>
                        <div className="dot-container">
                            <div className="step-dot dot-2"/>
                            <div className="step-line"/>
                        </div>
                        <div className="dot-container">
                            <div className="step-dot dot-3"/>
                        </div>
                    </div>
                    <div className="right-column">
                        <div className="process-item">
                            <div className="process-header-container">
                                <div className="step-number step-1">01.</div>
                                <h3 className="process-header header-1">Tell Us The Amount and Type of Loan You
                                    Need. </h3>
                                <p className="process-step-text">Whether you need $1,000 or $100,000, we’ve got you
                                    covered. With easy payback options, {props.config.name} makes borrowing money a breeze.</p>
                            </div>
                        </div>
                        <div className="process-item">
                            <div className="process-header-container">
                                <div className="step-number step-2">02.</div>
                                <h3 className="process-header header-2">Fill Out Some Information About Yourself.</h3>
                            </div>
                            <p className="process-step-text">Take 2 minutes to complete the form below and we will
                                present personalized loan offers from leading industry lenders. </p>
                        </div>
                        <div className="process-item">
                            <div className="process-header-container">
                                <div className="step-number step-3">03.</div>
                                <h3 className="process-header header-3">Get Multiple Loan Offers Personalized for
                                    You!</h3>
                            </div>
                            <p className="process-step-text">Get real-time offers from lenders such as Prosper, Lending
                                Club, Sofi and many more. Choose which loan works best for you! </p>
                        </div>
                    </div>
                </div>
            </div>
            {/*<div className="stack-parallax-2 slide-text-large">*/}

            {/*</div>*/}
        </div>
    )
}

export default DotSection;
